<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Capa_1"
    enable-background="new 0 0 512 512"
    height="512"
    viewBox="0 0 512 512"
    width="512"
  >
    <title>Resume</title>
    <path d="m142.468 94.267h66.398v66.399h-66.398z" />
    <path d="m360.433 128.533h94.581l-119.747-119.746v94.58c0 13.877 11.29 25.166 25.166 25.166z" />
    <path
      d="m360.433 158.533c-30.418 0-55.166-24.747-55.166-55.166v-103.367h-201.9c-30.419 0-55.167 24.748-55.167 55.167v401.666c0 30.419 24.748 55.167 55.166 55.167h305.268c30.419 0 55.166-24.748 55.166-55.167v-298.3zm-247.965-79.266c0-8.284 6.715-15 15-15h96.398c8.285 0 15 6.716 15 15v96.399c0 8.284-6.715 15-15 15h-96.398c-8.285 0-15-6.716-15-15zm15 145.667h192.799c8.285 0 15 6.716 15 15s-6.715 15-15 15h-192.799c-8.285 0-15-6.716-15-15 0-8.285 6.715-15 15-15zm257.066 222.798h-257.066c-8.285 0-15-6.716-15-15s6.715-15 15-15h257.066c8.283 0 15 6.716 15 15 0 8.285-6.717 15-15 15zm0-64.265h-257.066c-8.285 0-15-6.716-15-15s6.715-15 15-15h257.066c8.283 0 15 6.716 15 15s-6.717 15-15 15zm0-64.268h-257.066c-8.285 0-15-6.716-15-15s6.715-15 15-15h257.066c8.283 0 15 6.716 15 15s-6.717 15-15 15z"
    />
  </svg>
</template>

<script>
export default {};
</script>